import {PARTIES} from '../content/parties';
import {rnd} from './rng';
import {lr} from './rules';
import {S} from './state';

/**
 * Wahlergebnis. `you` ist der Anteil des Kanzler-Platzes, `fixed` legt Anteile weiterer Parteien
 * fest (Spielerparteien im Mehrspieler). Die übrigen Parteien teilen sich den Rest.
 */
export function electionResult(you?:any,fixed?:Record<string,number>){
  you=you||0;fixed=fixed||{};
  const sh:any={YOU:you};let o=0,fx=0;
  for(const k in fixed){if(PARTIES[k]){sh[k]=Math.max(1,fixed[k]);fx+=sh[k]}}
  for(const k in PARTIES){if(k in fixed)continue;sh[k]=Math.max(2,PARTIES[k].base+(rnd()*6-3)-(S.partners.includes(k)?1:0));o+=sh[k]}
  const f=Math.max(0,100-you-fx)/(o||1);for(const k in PARTIES)if(!(k in fixed))sh[k]*=f;
  const inP=Object.keys(sh).filter((k:any)=>sh[k]>=5);const tot=inP.reduce((s:any,k:any)=>s+sh[k],0);
  const seats:any={};let used=0;const rem:any=[];
  inP.forEach((k:any)=>{const q=630*sh[k]/tot;seats[k]=Math.floor(q);used+=seats[k];rem.push([k,q-seats[k]])});
  rem.sort((a:any,b:any)=>b[1]-a[1]);for(let i=0;i<630-used;i++)seats[rem[i][0]]++;
  inP.sort((a:any,b:any)=>lr(a)-lr(b));
  return{share:sh,seats,inP};
}
export const isWon=(r:any)=>Object.keys(r.share).every((k:any)=>r.share.YOU>=r.share[k]);
export function runElection(){S.partners=[];S.res=electionResult(29+rnd()*4);S.elec=S.res.share.YOU;S.elYear=2029;S.phase='night'}
export const lawsLeg:any=()=>S.laws.filter((L)=>['kraft','done'].includes(L.stage)&&(L.leg??0)===S.leg).length;
export function coalSeats(){return (S.res.seats.YOU||0)+S.partners.reduce((s:any,p:any)=>s+S.res.seats[p],0)}
